import { useEffect } from 'react';
import { connect } from 'react-redux';

import { nsRegisterFcmToken } from 'GraphQL/mutation/FCMToken.mutation';
import { isLoading, myProfile } from 'Redux/user-profile/selectors';
import { FCMPlugin } from 'Util/Capacitors/SkooldioCapacitor';

import { getStoreApolloClient } from '../../GraphQL';

const FCMUserListener = ({ user }) => {
  useEffect(() => {
    const registerDeviceFCMToken = async () => {
      try {
        const { token } = await FCMPlugin.getToken();
        if (!token) return;

        const storeApolloClient = getStoreApolloClient();
        await storeApolloClient.mutate({
          mutation: nsRegisterFcmToken,
          variables: { token },
        });
      } catch (error) {
        console.error('FCMToken registration Error: ', error);
      }
    };

    if (user) {
      registerDeviceFCMToken();
    }
  }, [user]);

  return null;
};

export default connect(
  (state) => ({
    user: myProfile(state),
    isLoading: isLoading(state),
  }),
  {}
)(FCMUserListener);
